import { useEffect, useState } from "react";
import { Box, Flex } from "reflexbox";
import { Separator, Text } from "src/common-ui";
import { TextInput } from "src/common-ui/Form";
import { useField } from "react-final-form";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";
import { useThemeUI } from "theme-ui";
import { required } from "src/helpers/validator";

export function LocationSearchField() {
  const { input, meta } = useField("adress", { validate: required });
  const [location, setLocation] = useState({ adress: input?.value?.adress });
  const { theme }: any = useThemeUI();

  useEffect(() => {
    if (input?.value) {
      setLocation({ adress: input?.value?.adress });
    }
  }, [input?.value]);

  const handleSelect = async (address) => {
    try {
      const adress = await geocodeByAddress(address);
      input.onChange({
        adress: adress?.[0]?.formatted_address,
        lat: adress?.[0]?.geometry?.location?.lat(),
        lng: adress?.[0]?.geometry?.location?.lng(),
      });

      setLocation({ adress: adress?.[0]?.formatted_address });
    } catch (e) {
      console.error(e);
    }
  };

  const handleChange = (adress) => {
    setLocation({ adress });
  };

  return (
    <>
      <PlacesAutocomplete value={location?.adress} onChange={handleChange} onSelect={handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <Flex my={"5px"} flexDirection="column" style={{ position: "relative" }}>
            <Box>
              <TextInput
                width={"100%"}
                validate={required}
                label="Adresse de votre établissement"
                {...getInputProps({
                  placeholder: "Entrez l'adresse de votre établissement",
                })}
              />
            </Box>
            {!!suggestions?.length && (
              <Box style={{ zIndex: 9999, position: "absolute", top: "65px" }} width="100%">
                {suggestions.map((suggestion) => {
                  // inline style for demonstration purpose
                  const style = {
                    background: "white",
                    padding: "5px",
                    color: theme.colors.secondary.main,
                    "&:hover": {
                      color: "white",
                      background: theme.colors.primary.light,
                    },
                  };

                  return (
                    <>
                      <Box
                        key={suggestion.description}
                        {...getSuggestionItemProps(suggestion, {
                          style,
                        })}
                      >
                        <Text color="secondary.dark">{suggestion.description}</Text>
                      </Box>
                      <Separator />
                    </>
                  );
                })}
              </Box>
            )}
          </Flex>
        )}
      </PlacesAutocomplete>
      {meta.submitFailed && (
        <Box fontSize="0.8em" fontStyle="italic" color="red.main" mt="4px">
          {meta.error}
        </Box>
      )}
    </>
  );
}
